import { render, staticRenderFns } from "./AppDialog.vue?vue&type=template&id=a37e2678"
import script from "./AppDialog.vue?vue&type=script&lang=js"
export * from "./AppDialog.vue?vue&type=script&lang=js"
import style0 from "./AppDialog.vue?vue&type=style&index=0&id=a37e2678&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports